<span>
    <a href="javascript:void(0)" (click)="onClick()" style="height: 100%">
        <img *ngIf="isValidImage" [src]="src" alt='' [style.width.px]="width" [style.height]="'auto'" />
    </a>
</span>
<img *ngIf="busy" src="{{localImageLocation}}ajax-loader.gif" class="link-busy" alt="loading">
